import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from '@/constants/Common'
import * as Yup from 'yup'

export const createSignInValidationSchema = (t: any) => {
  return Yup.object().shape({
    email: Yup.string().email(t('constant.emailInvalid')).required(t('constant.emailRequired')),
    password: Yup.string()
      .required(t('constant.passRequired'))
      .matches(/^\S*$/, t('constant.passNoWhiteSpace'))
      .min(MIN_PASSWORD_LENGTH, t('constant.passMinLength'))
      .max(MAX_PASSWORD_LENGTH, t('constant.passMaxLength'))
      .matches(/^(?=.*[a-zA-Z])/, t('constant.passLettersNumbers'))
      .matches(/^(?=.*[0-9])(?=.{6,})/, t('constant.passOneNumbers')),
  })
}
